import { useState, useEffect, useRef } from 'react'
import { ESortOrder } from '../components'
import { useSearchParams } from 'react-router'
import * as lib from '../lib'

export const REVENUE_SPEND_BY_TEAM_PAGE_SORT_FIELDS = ['at'] as const

export type IRevenueSpendByTeamSortField = typeof REVENUE_SPEND_BY_TEAM_PAGE_SORT_FIELDS[number]

type IUseSortRevenueSpendByTeamPage = {
	sortBy: IRevenueSpendByTeamSortField;
	setSortBy: (value: (((prevState: IRevenueSpendByTeamSortField) => IRevenueSpendByTeamSortField) | IRevenueSpendByTeamSortField)) => void;
	order: ESortOrder;
	setOrder: (value: (((prevState: ESortOrder) => ESortOrder) | ESortOrder)) => void;
}

const DEFAULT_SORT_BY: IRevenueSpendByTeamSortField = 'at'
const DEFAULT_SORT_ORDER: ESortOrder = ESortOrder.desc
export const useRevenueSpendByTeamSortPage = (team: string): IUseSortRevenueSpendByTeamPage => {
	const isFirstRender = useRef<boolean>(true)
	const [teamPrev, setTeamPrev] = useState<string>(team)
	const [searchParams, setSearchParams] = useSearchParams()

	const urlSort = (() => {
		try {
			return lib.sortSearchParams(searchParams.get('s')) ?? []
		} catch (error) {
			console.error(error)
			return []
		}
	})().filter((item) => {
		const sortOrderValues = Object.values(ESortOrder)

		return REVENUE_SPEND_BY_TEAM_PAGE_SORT_FIELDS.includes(item[0] as IRevenueSpendByTeamSortField) && sortOrderValues.includes(item[1] as ESortOrder)
	})

	const [sortBy, setSortBy] = useState<IRevenueSpendByTeamSortField>(urlSort?.[0]?.[0] as IRevenueSpendByTeamSortField ?? DEFAULT_SORT_BY)
	const [order, setOrder] = useState<ESortOrder>(urlSort?.[0]?.[1] as ESortOrder ?? DEFAULT_SORT_ORDER)

	useEffect(() => {
		let _sortBy = sortBy
		let _order = order
		// reset sort logic [RSL] onTeam (menu tabs) changed
		if (!isFirstRender.current && teamPrev !== team) {
			setTeamPrev(team)
			_sortBy = DEFAULT_SORT_BY
			_order = DEFAULT_SORT_ORDER
			setSortBy(DEFAULT_SORT_BY)
			setOrder(DEFAULT_SORT_ORDER)
		}

		if (_sortBy && _order) {
			const newSortStr = lib.sortSetup([[_sortBy, _order]])

			setSearchParams((prev) => {
				if (!isFirstRender.current) {
					if (_order !== ESortOrder.unset) {
						prev.set('s', newSortStr)
					} else {
						prev.delete('s')
					}
				} else {
					isFirstRender.current = false
				}

				return prev
			})
		}
	}, [team, sortBy, order])

	return {
		// sort: order !== ESortOrder.unset ? [[sortBy, order]] : [],
		sortBy,
		setSortBy,
		order,
		setOrder
	}
}